/* "Was steckt drin?" on the product page.
   Default markup is a static, labelled still (the cake in layers): that is what users see without JS,
   with reduced motion and in data-saver mode. With motion allowed, a short muted clip loops like a GIF while
   the section is in view (layers come apart, hold, go back together); the numbered pins show while the
   layers are apart. Paused off-screen. If autoplay is blocked (e.g. iOS Low Power Mode) the labelled still
   stays and a tap on the image starts the loop. */
(function () {
  'use strict';
  var ana = document.querySelector('[data-om-ana2]');
  if (!ana) return;
  var v = ana.querySelector('video');
  var src = ana.getAttribute('data-src'), start = ana.getAttribute('data-start');
  var fwd = parseFloat(ana.getAttribute('data-fwd'));
  if (!v || !src) return;
  var calm = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  if (calm) return;
  var cn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  if (cn && (cn.saveData || /(^|-)2g$/.test(cn.effectiveType || ''))) return;
  if (!('IntersectionObserver' in window)) return;

  // Pins show from just before the layers are fully apart until they start moving back (hold = 1.8 s).
  var pinOn = fwd - 0.15, pinOff = fwd + 1.7;
  var inView = false, raf = 0, blocked = false;

  v.muted = true; v.defaultMuted = true; v.loop = true;
  v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', '');

  var load = function () {
    if (v.getAttribute('src')) return;
    if (start) v.poster = start;
    v.preload = 'auto';
    v.src = src;
  };
  var pins = function () {
    var t = v.currentTime;
    ana.classList.toggle('is-apart', isNaN(fwd) || (t >= pinOn && t <= pinOff));
    if (!v.paused) raf = window.requestAnimationFrame(pins);
  };
  var still = function () {
    // Back to the labelled still with pins (autoplay blocked or the clip failed).
    window.cancelAnimationFrame(raf);
    ana.classList.remove('is-live', 'is-apart');
    try { v.pause(); } catch (e) {}
  };
  var play = function () {
    load();
    var p;
    try { p = v.play(); } catch (e) { blocked = true; still(); return; }
    if (p && typeof p.then === 'function') {
      p.then(function () { blocked = false; ana.classList.add('is-live'); }, function () { blocked = true; still(); });
    } else ana.classList.add('is-live');
  };

  v.addEventListener('playing', function () { window.cancelAnimationFrame(raf); raf = window.requestAnimationFrame(pins); });
  v.addEventListener('error', still);
  // A tap is a user gesture, so it can start the loop where autoplay was refused.
  var media = ana.querySelector('.om-ana-media') || ana;
  media.addEventListener('click', function () { if (blocked || v.paused) play(); });

  new IntersectionObserver(function (en, ob) {
    if (en[0].isIntersecting) {
      ob.disconnect();
      if (start) { var im = new Image(); im.src = start; }
      load();
    }
  }, { rootMargin: '600px 0px' }).observe(ana);

  new IntersectionObserver(function (en) {
    inView = en[0].isIntersecting;
    if (inView) { if (!blocked) play(); }
    else if (!v.paused) { try { v.pause(); } catch (e) {} }
  }, { threshold: 0.35 }).observe(media);
})();
